import React from 'react'
import {KTIcon} from '../../_metronic/helpers'

const SearchQueryData = ({
  value,
  handleChange,
  handleKeyDown,
  fetchData,
  placeholder = 'Search',
}: {
  value: string
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  fetchData: (query?: string) => void
  placeholder?: string
}) => {
  return (
    <div className='d-flex align-items-center position-relative my-1'>
      <button
        className='position-absolute end-0 bg-primary rounded border border-none'
        onClick={() => fetchData(value)}
        type='button'
      >
        <KTIcon iconName='magnifier' className='fs-1 text-white p-3 ' />
      </button>
      <input
        type='text'
        data-kt-user-table-filter='search'
        className='form-control form-control-solid w-300px'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  )
}

export default SearchQueryData
